import { Component } from '@angular/core';

@Component({
    selector: 'app-all-spending',
    standalone: true,
    imports: [],
    templateUrl: './all-spending.component.html',
    styleUrl: './all-spending.component.scss'
})
export class AllSpendingComponent {}